import { SxStyles } from '../../../types';
import theme from '../../../theme';
import { getResponsiveSize } from '../../../utils';

export const ViewSwapToggleStyle: SxStyles = {
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: getResponsiveSize(89),
    px: getResponsiveSize(8),
  },
  checkbox: {
    p: getResponsiveSize(6),
    borderRadius: '50%',
    transition: theme.palette.propVars?.easeInOutTransition,
    color: theme.palette.mainControls?.viewSwapIdle,
    '&:hover': {
      backgroundColor: 'rgba(81, 126, 197, 0.08)',
    },
    '&.Mui-checked': {
      color: theme.palette.mainControls?.viewSwapActive,
      '&:hover': {
        backgroundColor: 'rgba(81, 126, 197, 0.12)',
      },
    },
    '& .MuiSvgIcon-root': {
      fontSize: getResponsiveSize(34),
      transition: theme.palette.propVars?.easeInOutTransition,
    },
    [theme.breakpoints.media?.laptop!]: {
      '& .MuiSvgIcon-root': {
        fontSize: getResponsiveSize(30),
      },
    },
    [theme.breakpoints.media?.tablet!]: {
      '& .MuiSvgIcon-root': {
        fontSize: getResponsiveSize(28),
      },
    },
  },
};
